import { render } from "./RecipeInstructions.vue?vue&type=template&id=4f7ca4c4&scoped=true&ts=true"
import script from "./RecipeInstructions.vue?vue&type=script&lang=ts"
export * from "./RecipeInstructions.vue?vue&type=script&lang=ts"

import "./RecipeInstructions.vue?vue&type=style&index=0&id=4f7ca4c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7ca4c4"]])

export default __exports__